var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE5\xBD\xA2\xE7\x8A\xB6 19 \xE6\x8B\xB7\xE8\xB4\x9D 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.7553 12.5931C15.038 12.7253 14.3376 12.9138 13.64 13.1388C12.5442 13.4763 10.7113 13.7604 9.72851 13.721C8.4435 13.7969 7.23474 13.0994 6.66708 11.9518C6.66708 11.9518 6.87607 13.3638 7.76286 14.2864C8.29099 14.832 9.65225 15.3214 10.9005 14.8686C12.9792 14.1542 15.4532 12.6859 16.436 13.4566C17.5685 14.3398 17.2098 15.583 16.3032 16.1652C15.4729 16.7109 12.8464 17.2763 9.49974 17.6335C8.04528 17.6532 6.59082 17.3128 5.28604 16.6912C3.83158 15.9937 2.50986 14.4326 2.14836 13.3047C1.05257 9.78604 3.33735 7.00146 3.33735 7.00146C1.5807 7.43462 1.25874 8.50626 1.0328 9.58071C0.541394 12.0643 -0.687131 15.4705 0.50468 17.2397C1.99868 19.4589 4.94432 19.8358 4.94432 19.8358C6.24909 20.0243 7.57082 20.0439 8.8756 19.9286V19.9483C8.8756 19.9483 15.922 18.781 17.5487 16.0724C18.5682 14.3032 17.8142 12.2725 15.7525 12.5903L15.7553 12.5931Z",
    fill: "url(#paint0_linear_5092_138848)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xE5\xBD\xA2\xE7\x8A\xB6 20 \xE6\x8B\xB7\xE8\xB4\x9D 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.56857 6.92851C1.71589 9.71308 2.09434 11.8395 2.09434 11.8395C2.22707 11.8029 3.34263 11.5385 6.00585 11.6707C6.15835 11.6707 6.28827 11.6904 6.44077 11.7073C4.79709 9.29962 4.62764 7.19009 4.60787 6.64443C4.2492 6.70068 3.90747 6.79632 3.56857 6.9257V6.92851ZM12.6003 9.63714C12.4309 8.88334 12.0722 8.43331 10.711 7.66263C9.84111 7.20978 8.93454 6.89195 7.97149 6.68381C8.29345 7.15353 10.0501 9.65683 12.5806 10.1266C12.6371 9.97466 12.6371 9.8059 12.6003 9.63714ZM7.6693 6.64443H7.70601C6.79945 6.47567 5.85334 6.47567 4.94677 6.58818C5.15576 9.11117 6.07928 10.8044 6.79945 11.7439C8.89782 12.0814 9.72814 13.2318 9.72814 13.2318C10.2563 12.1039 11.9395 10.6356 12.0327 10.5963C12.2219 10.54 12.3716 10.4444 12.5043 10.315C11.5215 10.1462 9.65189 9.41213 7.66647 6.64443H7.6693Z",
    fill: "url(#paint1_linear_5092_138848)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.3174 10.3738C12.3174 10.3738 11.2978 11.3161 10.7104 11.918C10.123 12.5199 10.0298 12.7646 9.70781 13.254C9.46211 13.5915 8.93398 13.479 8.53577 13.2737C7.13779 12.3905 6.06177 11.1107 5.45457 9.58627C4.56777 7.32767 4.88691 6.55699 5.01964 6.10415C5.15238 5.6513 5.70028 4.05369 5.81324 3.43208C5.92621 2.81048 6.26794 1.96385 7.34396 1.04129C7.34396 1.04129 5.86973 3.35614 6.90903 5.25752C7.94834 7.15891 8.95093 9.0406 12.3117 10.3766L12.3174 10.3738ZM14.17 1.94417C13.5657 1.21005 12.7721 0.644699 11.8655 0.34374C11.0888 0.0596579 10.2585 -0.05285 9.44516 0.0230928C9.38868 1.24662 10.4845 3.12831 10.4845 3.12831C10.8234 3.05237 11.7497 2.67547 12.9782 3.29707C14.3 3.95525 14.8676 6.3826 14.8676 6.3826C14.8676 6.3826 15.9832 4.29277 14.1672 1.94135L14.17 1.94417ZM10.2388 3.22394C8.7843 3.6571 7.12085 4.91719 7.12085 4.91719C6.29053 2.67828 7.74499 0.945658 7.74499 0.945658C8.19969 0.475937 8.80407 0.0793468 9.19946 0.0624706C9.19946 0.889404 9.9168 2.54608 10.2388 3.22394Z",
    fill: "url(#paint2_linear_5092_138848)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5092_138848",
    x1: 0.004797,
    y1: 13.5044,
    x2: 18.0034,
    y2: 13.5044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EDC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86D5B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5092_138848",
    x1: 2.06327,
    y1: 9.87341,
    x2: 12.6286,
    y2: 9.87341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EDC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86D5B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5092_138848",
    x1: 4.85584,
    y1: 6.73419,
    x2: 15.2065,
    y2: 6.73419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#168C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EDC28"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2730a9254a2f1811bd36781242f5af5e.svg";
export { ForwardRef as ReactComponent };